import { Typography, styled } from '@mui/material';
import React from 'react';

const StyledTypography = styled(Typography)(({ theme }) => ({
    marginTop:3,
    color: theme.palette.neutral.dark60,
    fontSize: '36px'
  }));

export default StyledTypography;